module.exports = __webpack_public_path__ + "img/logoCheckoutRed.0e909c9b.svg";